import styles from "./CourseThumbnail.module.css";

// Renders a course thumbnail.
// If thumbnail.image is provided, use it.
// Otherwise fall back to the CSS gradient + emoji + pattern look.
export default function CourseThumbnail({ thumbnail, title, size = "card" }) {
  if (!thumbnail) return null;

  // ── Image mode ─────────────────────────────────────────────────────────
  if (thumbnail.image) {
    return (
      <div className={[styles.thumb, styles[`thumb--${size}`]].join(" ")}>
        <img
          src={thumbnail.image}
          alt={title}
          className={styles.thumbImage}
          loading="lazy"
        />
      </div>
    );
  }

  // ── CSS fallback mode ──────────────────────────────────────────────────
  const { gradient, emoji, pattern, accent } = thumbnail;
  const patternStyle = getPattern(pattern, accent);

  return (
    <div
      className={[styles.thumb, styles[`thumb--${size}`]].join(" ")}
      style={{ background: gradient }}
    >
      <div className={styles.pattern} style={patternStyle} />
      <div className={styles.orb} style={{ background: accent }} />

      <div className={styles.pdfStack}>
        <div className={styles.pdfPage} style={{ borderColor: `${accent}40` }}>
          <div className={styles.pdfLines}>
            {[80, 65, 90, 55, 75].map((w, i) => (
              <div key={i} className={styles.pdfLine} style={{ width: `${w}%`, background: `${accent}50` }} />
            ))}
          </div>
        </div>
        <div className={styles.pdfPageBehind} style={{ borderColor: `${accent}25` }} />
      </div>

      <div className={styles.emoji}>{emoji}</div>

      <div
        className={styles.pdfBadge}
        style={{ color: accent, borderColor: `${accent}50`, background: `${accent}15` }}
      >
        PDF
      </div>
    </div>
  );
}

function getPattern(pattern, accent) {
  switch (pattern) {
    case "dots":
      return {
        backgroundImage: `radial-gradient(circle, ${accent}22 1.5px, transparent 1.5px)`,
        backgroundSize:  "18px 18px",
      };
    case "grid":
      return {
        backgroundImage: `linear-gradient(${accent}18 1px, transparent 1px), linear-gradient(90deg, ${accent}18 1px, transparent 1px)`,
        backgroundSize:  "24px 24px",
      };
    case "lines":
      return {
        backgroundImage: `repeating-linear-gradient(45deg, ${accent}12 0, ${accent}12 1px, transparent 0, transparent 50%)`,
        backgroundSize:  "12px 12px",
      };
    case "radial":
    default:
      return {
        backgroundImage: `radial-gradient(ellipse at 70% 30%, ${accent}20 0%, transparent 60%)`,
      };
  }
}